import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShift: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconShift"><Path d="M13.2507 2.45765C12.5641 1.75516 11.434 1.75516 10.7475 2.45765L2.37301 11.0269C1.29008 12.135 2.07519 14 3.62459 14H6.1175V18.25C6.1175 19.7688 7.34872 21 8.8675 21H15.1307C16.6494 21 17.8807 19.7688 17.8807 18.25V14H20.3736C21.923 14 22.7081 12.135 21.6252 11.0269L13.2507 2.45765Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShift;
